import React, { useState, useEffect } from 'react';
import './CreativeBriefForm.css';
import ProgressLoader from './ProgressLoader';

const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan',
  'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi',
  'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
  'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
  'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia',
  'Fiji', 'Finland', 'France',
  'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hungary',
  'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
  'Jamaica', 'Japan', 'Jordan',
  'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan',
  'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar',
  'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway',
  'Oman',
  'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
  'Qatar',
  'Romania', 'Russia', 'Rwanda',
  'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria',
  'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
  'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan',
  'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
  'Yemen',
  'Zambia', 'Zimbabwe'
];

const INDUSTRIES = [
  'E-commerce / Online Shopping',
  'Fashion & Apparel',
  'Footwear',
  'Beauty & Personal Care',
  'Health & Wellness',
  'Fitness / Sports & Outdoors',
  'Electronics & Gadgets',
  'Mobile Apps / SaaS',
  'Fintech / Banking / Insurance',
  'Edtech / Online Learning',
  'Food Delivery / Restaurants',
  'Travel & Hospitality',
  'Real Estate',
  'Automobiles / Mobility',
  'Home & Living / Furniture',
  'Grocery / Quick Commerce',
  'Gaming',
  'Entertainment / OTT / Media',
  'Telecom / Internet Services',
  'B2B / Enterprise Solutions',
  'Others'
];

const BRAND_PERSONALITIES = [
  'Premium',
  'Mass-market / Value for Money',
  'Fun & Playful',
  'Bold & Edgy',
  'Minimal & Modern',
  'Traditional / Heritage',
  'Trustworthy / Reliable',
  'Youthful',
  'Family-friendly',
  'Innovative / Tech-forward',
  'Aspirational / Luxurious',
  'Professional / Serious',
  'Quirky / Offbeat',
  'Warm & Caring',
  'Eco-conscious / Sustainable'
];

const CAMPAIGN_GOALS = [
  'Brand Awareness / Reach',
  'Video Views',
  'Traffic (Website / Landing Page Visits)',
  'App Installs',
  'Lead Generation (Form Fills)',
  'Add to Cart / Product Page Views',
  'Purchases / Sales / Conversions',
  'Repeat Purchases / Retention',
  'Store Visits / Offline Footfall',
  'Engagement (Likes, Comments, Shares)',
  'Other'
];

const AGE_GROUPS = ['13-17', '18-24', '25-34', '35-44', '45-54', '55+'];

const GENDERS = ['All', 'Male', 'Female', 'Other / Non-binary', 'Custom'];

const AUDIENCE_TYPES = [
  'New Users / Prospecting',
  'Retargeting – Website Visitors',
  'Retargeting – App Users',
  'Retargeting – Add to Cart, No Purchase',
  'Retargeting – Past Purchasers',
  'High-Value / Loyal Customers',
  'Lookalike of Converters / Purchasers',
  'Lookalike of Website Visitors',
  'CRM List / Custom List',
  'Interest-based Audience',
  'Contextual / Content-based Audience',
  'Other'
];

const OFFER_TYPES = [
  'No Offer / Always-On Campaign',
  'Flat Discount (%)',
  'Flat Discount (Value)',
  'Tiered Discount',
  'Cashback',
  'Free Shipping',
  'Buy X Get Y',
  'Free Trial / Demo',
  'Introductory Offer / Launch Offer',
  'Seasonal Sale',
  'EMI / No-Cost EMI / Financing',
  'Loyalty / Referral Rewards',
  'Other'
];

const CREATIVE_OBJECTIVES = [
  'Drive Clicks to Website / App Store',
  'Drive App Installs',
  'Drive Product Page Visits',
  'Drive Purchases / Transactions',
  'Drive Form Fills / Leads',
  'Drive Store Visits',
  'Drive Video Views / Completion',
  'Drive Engagement',
  'Drive Add to Cart / Wishlist',
  'Educate about New Feature / Launch',
  'Promote Limited-time Offer / Sale',
  'Other'
];

const CREATIVE_FORMATS = [
  { value: '1080x1080', label: '1:1 (Square Feed/Carousel)' },
  { value: '1080x1350', label: '4:5 (Vertical Feed)' },
  { value: '1080x1920', label: '9:16 (Stories/Reels)' },
  { value: '1920x1080', label: '1.91:1 (Landscape Feed)' }
];

const COMMON_FONTS = [
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Georgia',
  'Verdana',
  'Courier New',
  'Trebuchet MS',
  'Comic Sans MS',
  'Impact',
  'Lucida Sans',
  'Tahoma',
  'Palatino',
  'Garamond',
  'Bookman',
  'Avant Garde',
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Raleway',
  'Poppins',
  'Nunito',
  'Playfair Display',
  'Merriweather',
  'Source Sans Pro',
  'Inter',
  'SF Pro Display',
  'Segoe UI',
  'Ubuntu',
  'Proxima Nova'
];

const FONT_USAGE_TYPES = [
  'Primary',
  'Secondary'
];

function CreativeBriefForm() {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);

  // Step 1: Mandatory fields
  const [brandName, setBrandName] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [referenceAds, setReferenceAds] = useState([]);
  const [referenceAdUrls, setReferenceAdUrls] = useState('');
  const [isProductAd, setIsProductAd] = useState(false);
  const [productImage, setProductImage] = useState(null);
  const [country, setCountry] = useState('');

  // Product analysis data from Step 1
  const [productAnalysis, setProductAnalysis] = useState(null);
  const [productImagePath, setProductImagePath] = useState(null);
  const [brandLogoPath, setBrandLogoPath] = useState(null);

  // Brand Guidelines from Step 1
  const [colorPalette, setColorPalette] = useState([]);
  const [fonts, setFonts] = useState([]);
  const [contentGuidelines, setContentGuidelines] = useState('');

  // Brand Guidelines UI state
  const [guidelinesExpanded, setGuidelinesExpanded] = useState(false);
  const [activeGuidelineTab, setActiveGuidelineTab] = useState('design'); // 'design' or 'content'
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
  const [isFontPickerOpen, setIsFontPickerOpen] = useState(false);
  const [isEditingContent, setIsEditingContent] = useState(false);
  const [tempColor, setTempColor] = useState('#3498DB');
  const [tempColorHex, setTempColorHex] = useState('#3498DB');
  const [tempFontFamily, setTempFontFamily] = useState('Arial');
  const [tempFontUsage, setTempFontUsage] = useState('Subheading');
  const [fontSearchQuery, setFontSearchQuery] = useState('');
  const [fontDropdownOpen, setFontDropdownOpen] = useState(false);
  const [hue, setHue] = useState(200);
  const [saturation, setSaturation] = useState(70);
  const [brightness, setBrightness] = useState(85);
  const [isDraggingGradient, setIsDraggingGradient] = useState(false);
  const [showCopyToast, setShowCopyToast] = useState(false);

  // Step 2: Auto-filled & editable fields
  const [industryCategory, setIndustryCategory] = useState('');
  const [brandDescription, setBrandDescription] = useState('');
  const [brandPersonality, setBrandPersonality] = useState([]);
  const [keyCompetitors, setKeyCompetitors] = useState('');
  const [primaryCampaignGoal, setPrimaryCampaignGoal] = useState('');
  const [ageGroups, setAgeGroups] = useState([]);
  const [gender, setGender] = useState('All');
  const [targetLocations, setTargetLocations] = useState('');
  const [languages, setLanguages] = useState('');
  const [audienceType, setAudienceType] = useState([]);
  const [offerType, setOfferType] = useState('');
  const [offerDetails, setOfferDetails] = useState('');
  const [creativeObjective, setCreativeObjective] = useState('');
  const [creativeFormats, setCreativeFormats] = useState(['1080x1080']);
  const [additionalNotes, setAdditionalNotes] = useState('');
  const [numberOfVariants, setNumberOfVariants] = useState(2);

  const [creatives, setCreatives] = useState([]);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(0);
  const [progressMessage, setProgressMessage] = useState('');
  const [targetProgress, setTargetProgress] = useState(0);

  // Smooth progress animation
  useEffect(() => {
    if (progress < targetProgress) {
      const increment = Math.max(1, (targetProgress - progress) / 20);
      const timer = setTimeout(() => {
        setProgress(prev => Math.min(prev + increment, targetProgress));
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [progress, targetProgress]);

  // Load form data from localStorage on mount
  useEffect(() => {
    const savedData = localStorage.getItem('creativeBriefFormData');
    if (savedData) {
      const parsed = JSON.parse(savedData);
      if (parsed.brandName) setBrandName(parsed.brandName);
      if (parsed.websiteUrl) setWebsiteUrl(parsed.websiteUrl);
      if (parsed.country) setCountry(parsed.country);
      if (parsed.industryCategory) setIndustryCategory(parsed.industryCategory);
      if (parsed.brandDescription) setBrandDescription(parsed.brandDescription);
      if (parsed.brandPersonality) setBrandPersonality(parsed.brandPersonality);
      if (parsed.keyCompetitors) setKeyCompetitors(parsed.keyCompetitors);
      if (parsed.primaryCampaignGoal) setPrimaryCampaignGoal(parsed.primaryCampaignGoal);
      if (parsed.ageGroups) setAgeGroups(parsed.ageGroups);
      if (parsed.gender) setGender(parsed.gender);
      if (parsed.targetLocations) setTargetLocations(parsed.targetLocations);
      if (parsed.languages) setLanguages(parsed.languages);
      if (parsed.audienceType) setAudienceType(parsed.audienceType);
      if (parsed.offerType) setOfferType(parsed.offerType);
      if (parsed.offerDetails) setOfferDetails(parsed.offerDetails);
      if (parsed.creativeObjective) setCreativeObjective(parsed.creativeObjective);
      if (parsed.creativeFormats) setCreativeFormats(parsed.creativeFormats);
      if (parsed.additionalNotes) setAdditionalNotes(parsed.additionalNotes);
      if (parsed.numberOfVariants) setNumberOfVariants(parsed.numberOfVariants);
      if (parsed.colorPalette) setColorPalette(parsed.colorPalette);

      // Handle fonts - convert object to array if needed
      if (parsed.fonts) {
        const fontsData = parsed.fonts;
        if (typeof fontsData === 'object' && !Array.isArray(fontsData)) {
          // New format: {primary: "...", secondary: "..."}
          const fontsArray = [];
          if (fontsData.primary) {
            fontsArray.push({ usage: 'Primary', family: fontsData.primary });
          }
          if (fontsData.secondary) {
            fontsArray.push({ usage: 'Secondary', family: fontsData.secondary });
          }
          setFonts(fontsArray);
        } else {
          // Already array format
          setFonts(fontsData);
        }
      }

      if (parsed.contentGuidelines) setContentGuidelines(parsed.contentGuidelines);
    }
  }, []);

  // Save form data to localStorage whenever relevant fields change
  useEffect(() => {
    const formData = {
      brandName,
      websiteUrl,
      country,
      industryCategory,
      brandDescription,
      brandPersonality,
      keyCompetitors,
      primaryCampaignGoal,
      ageGroups,
      gender,
      targetLocations,
      languages,
      audienceType,
      offerType,
      offerDetails,
      creativeObjective,
      creativeFormats,
      additionalNotes,
      colorPalette,
      fonts,
      contentGuidelines,
      numberOfVariants
    };
    localStorage.setItem('creativeBriefFormData', JSON.stringify(formData));
  }, [brandName, websiteUrl, country, industryCategory, brandDescription, brandPersonality,
      keyCompetitors, primaryCampaignGoal, ageGroups, gender, targetLocations, languages,
      audienceType, offerType, offerDetails, creativeObjective, creativeFormats,
      additionalNotes, numberOfVariants, colorPalette, fonts, contentGuidelines]);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setReferenceAds(files);
  };

  const handleProductImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProductImage(file);
    }
  };

  const handleBrandLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is SVG
      if (file.name.toLowerCase().endsWith('.svg')) {
        setError('SVG logos are not supported. Please upload PNG, JPG, or WebP format.');
        e.target.value = ''; // Reset input
        return;
      }

      // If we're in Step 2, upload the logo immediately and get the path
      if (step === 2) {
        try {
          const formData = new FormData();
          formData.append('brandLogo', file);

          const response = await fetch(`${API_URL}/upload-logo`, {
            method: 'POST',
            body: formData
          });

          const data = await response.json();
          if (data.logoPath) {
            setBrandLogoPath(data.logoPath);
          }
        } catch (err) {
          console.error('Error uploading logo:', err);
          setError('Failed to upload logo. Please try again.');
        }
      }
    }
  };

  // HSB to Hex conversion
  const hsbToHex = (h, s, b) => {
    s = s / 100;
    b = b / 100;
    const k = (n) => (n + h / 60) % 6;
    const f = (n) => b * (1 - s * Math.max(0, Math.min(k(n), 4 - k(n), 1)));
    const rgb = [f(5), f(3), f(1)].map(x => Math.round(x * 255));
    return '#' + rgb.map(x => x.toString(16).padStart(2, '0')).join('').toUpperCase();
  };

  // Hex to HSB conversion
  const hexToHsb = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    let h = 0;
    if (delta !== 0) {
      if (max === r) h = 60 * (((g - b) / delta) % 6);
      else if (max === g) h = 60 * ((b - r) / delta + 2);
      else h = 60 * ((r - g) / delta + 4);
    }
    if (h < 0) h += 360;

    const s = max === 0 ? 0 : (delta / max) * 100;
    const brightness = max * 100;

    return { h: Math.round(h), s: Math.round(s), b: Math.round(brightness) };
  };

  const handleOpenColorPicker = () => {
    const hsb = hexToHsb('#3498DB');
    setHue(hsb.h);
    setSaturation(hsb.s);
    setBrightness(hsb.b);
    setTempColor('#3498DB');
    setTempColorHex('#3498DB');
    setIsColorPickerOpen(true);
  };

  const updateGradientColor = React.useCallback((clientX, clientY, rect) => {
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const y = Math.max(0, Math.min(clientY - rect.top, rect.height));
    const newSat = (x / rect.width) * 100;
    const newBright = 100 - (y / rect.height) * 100;
    setSaturation(newSat);
    setBrightness(newBright);
    const newColor = hsbToHex(hue, newSat, newBright);
    setTempColor(newColor);
    setTempColorHex(newColor);
  }, [hue]);

  const handleGradientMouseDown = (e) => {
    setIsDraggingGradient(true);
    const rect = e.currentTarget.getBoundingClientRect();
    updateGradientColor(e.clientX, e.clientY, rect);
  };

  const handleGradientMouseMove = React.useCallback((e) => {
    if (!isDraggingGradient) return;
    const picker = document.querySelector('.gradient-picker');
    if (picker) {
      const rect = picker.getBoundingClientRect();
      updateGradientColor(e.clientX, e.clientY, rect);
    }
  }, [isDraggingGradient, updateGradientColor]);

  const handleGradientMouseUp = () => {
    setIsDraggingGradient(false);
  };

  const handleHueChange = (e) => {
    const newHue = parseFloat(e.target.value);
    setHue(newHue);
    const newColor = hsbToHex(newHue, saturation, brightness);
    setTempColor(newColor);
    setTempColorHex(newColor);
  };

  // Add global mouse event listeners for dragging
  React.useEffect(() => {
    if (isDraggingGradient) {
      document.addEventListener('mousemove', handleGradientMouseMove);
      document.addEventListener('mouseup', handleGradientMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleGradientMouseMove);
        document.removeEventListener('mouseup', handleGradientMouseUp);
      };
    }
  }, [isDraggingGradient, handleGradientMouseMove]);

  // Dynamically load Google Fonts for preview
  React.useEffect(() => {
    if (tempFontFamily && isFontPickerOpen) {
      const systemFonts = ['Arial', 'Helvetica', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New', 'Trebuchet MS', 'Comic Sans MS', 'Impact', 'Lucida Sans', 'Tahoma', 'Palatino', 'Garamond', 'Bookman', 'Avant Garde', 'Segoe UI'];

      // Only load if it's not a system font
      if (!systemFonts.includes(tempFontFamily)) {
        const fontName = tempFontFamily.replace(/ /g, '+');
        const linkId = 'google-font-preview';

        // Remove existing font link if any
        const existingLink = document.getElementById(linkId);
        if (existingLink) {
          existingLink.remove();
        }

        // Add new font link
        const link = document.createElement('link');
        link.id = linkId;
        link.rel = 'stylesheet';
        link.href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@400;500;600;700&display=swap`;
        document.head.appendChild(link);
      }
    }
  }, [tempFontFamily, isFontPickerOpen]);

  const handleColorHexChange = (e) => {
    const hex = e.target.value.toUpperCase();
    setTempColorHex(hex);
    if (/^#[0-9A-F]{6}$/i.test(hex)) {
      const hsb = hexToHsb(hex);
      setHue(hsb.h);
      setSaturation(hsb.s);
      setBrightness(hsb.b);
      setTempColor(hex);
    }
  };

  const handleCopyHex = () => {
    navigator.clipboard.writeText(tempColorHex);
    setShowCopyToast(true);
    setTimeout(() => setShowCopyToast(false), 3000);
  };

  const handleConfirmColor = () => {
    if (/^#[0-9A-F]{6}$/i.test(tempColorHex)) {
      setColorPalette([...colorPalette, tempColorHex]);
      setIsColorPickerOpen(false);
    } else {
      alert('Please enter a valid hex color (e.g., #FF5733)');
    }
  };

  const handleRemoveColor = (index) => {
    setColorPalette(colorPalette.filter((_, i) => i !== index));
  };

  const handleOpenFontPicker = () => {
    setTempFontFamily('Arial');
    setTempFontUsage('Primary');
    setFontSearchQuery('');
    setFontDropdownOpen(false); // Start with dropdown closed
    setIsFontPickerOpen(true);
  };

  const handleFontFamilyChange = (fontName) => {
    setTempFontFamily(fontName);
    setFontDropdownOpen(false); // Close dropdown after selection
  };

  const toggleFontDropdown = () => {
    setFontDropdownOpen(!fontDropdownOpen);
  };

  const handleConfirmFont = () => {
    if (tempFontFamily && tempFontFamily.trim()) {
      const fontEntry = {
        usage: tempFontUsage,
        family: tempFontFamily.trim()
      };

      // Check if a font with the same usage already exists
      const existingIndex = fonts.findIndex(f => f.usage === tempFontUsage);

      if (existingIndex !== -1) {
        // Replace existing font with the same usage
        const updatedFonts = [...fonts];
        updatedFonts[existingIndex] = fontEntry;
        setFonts(updatedFonts);
      } else {
        // Add new font
        setFonts([...fonts, fontEntry]);
      }

      setIsFontPickerOpen(false);
      setFontDropdownOpen(false);
    } else {
      alert('Please select a font');
    }
  };

  const filteredFonts = fontSearchQuery
    ? COMMON_FONTS.filter(font => font.toLowerCase().includes(fontSearchQuery.toLowerCase()))
    : COMMON_FONTS;

  const handleRemoveFont = (index) => {
    setFonts(fonts.filter((_, i) => i !== index));
  };

  const handleEditContent = () => {
    setIsEditingContent(true);
  };

  const handleSaveContent = () => {
    setIsEditingContent(false);
  };

  const handleCancelContentEdit = () => {
    setIsEditingContent(false);
  };

  const handleFetchDetails = async () => {
    setAnalyzing(true);
    setError(null);
    setProgress(0);
    setTargetProgress(0);
    setProgressMessage('Starting...');

    // Clear old logo when starting new analysis
    setBrandLogoPath(null);

    try {
      const formData = new FormData();
      formData.append('brandName', brandName);
      formData.append('websiteUrl', websiteUrl);
      formData.append('country', country);

      // Add product image if uploaded
      if (productImage) {
        formData.append('productImage', productImage);
      }

      // Brand logo will be extracted by backend from website

      // Add uploaded reference ads
      referenceAds.forEach((file) => {
        formData.append(`referenceAds`, file);
      });

      // Add reference URLs if provided
      if (referenceAdUrls.trim()) {
        formData.append('referenceAdUrls', referenceAdUrls);
      }

      const response = await fetch(`${API_URL}/analyze-brand-sse`, {
        method: 'POST',
        body: formData
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n\n');

        // Keep the last incomplete line in buffer
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = JSON.parse(line.substring(6));

              if (data.error) {
                throw new Error(data.error);
              }

              if (data.progress !== undefined) {
                setTargetProgress(data.progress);
                setProgressMessage(data.message || '');
              }

              if (data.complete && data.data) {
                // Set progress to 100% first
                setTargetProgress(100);
                setProgressMessage('Complete!');

                // Wait for animation to reach 100% before proceeding
                setTimeout(() => {
                  // Auto-fill fields from Gemini response
                  const analysis = data.data;
                  if (analysis.industryCategory) setIndustryCategory(analysis.industryCategory);
                  if (analysis.brandDescription) setBrandDescription(analysis.brandDescription);
                  if (analysis.brandPersonality) setBrandPersonality(analysis.brandPersonality);
                  if (analysis.keyCompetitors) setKeyCompetitors(analysis.keyCompetitors.join(', '));
                  if (analysis.primaryCampaignGoal) setPrimaryCampaignGoal(analysis.primaryCampaignGoal);
                  if (analysis.ageGroups) setAgeGroups(analysis.ageGroups);
                  if (analysis.gender) setGender(analysis.gender);
                  if (analysis.targetLocations) setTargetLocations(analysis.targetLocations.join(', '));
                  if (analysis.languages) setLanguages(analysis.languages.join(', '));
                  if (analysis.audienceType) setAudienceType(analysis.audienceType);
                  if (analysis.offerType) setOfferType(analysis.offerType);
                  if (analysis.creativeObjective) setCreativeObjective(analysis.creativeObjective);

                  // Store product analysis and file paths for Step 2
                  if (analysis.productAnalysis) setProductAnalysis(analysis.productAnalysis);
                  if (analysis.productImagePath) setProductImagePath(analysis.productImagePath);
                  // Clear old logo or set new one
                  setBrandLogoPath(analysis.brandLogoPath || null);

                  // Store brand guidelines
                  if (analysis.brandGuidelines) {
                    if (analysis.brandGuidelines.colorPalette) setColorPalette(analysis.brandGuidelines.colorPalette);

                    // Convert fonts object to array format
                    if (analysis.brandGuidelines.fonts) {
                      const fontsData = analysis.brandGuidelines.fonts;
                      const fontsArray = [];

                      if (typeof fontsData === 'object' && !Array.isArray(fontsData)) {
                        // New format: {primary: "...", secondary: "..."}
                        if (fontsData.primary) {
                          fontsArray.push({ usage: 'Primary', family: fontsData.primary });
                        }
                        if (fontsData.secondary) {
                          fontsArray.push({ usage: 'Secondary', family: fontsData.secondary });
                        }
                        setFonts(fontsArray);
                      } else if (Array.isArray(fontsData)) {
                        // Old format or already array - keep as is
                        setFonts(fontsData);
                      }
                    }

                    if (analysis.brandGuidelines.contentGuidelines) setContentGuidelines(analysis.brandGuidelines.contentGuidelines);
                  }

                  setStep(2);
                }, 1000); // Wait 1 second for animation to complete
              }
            } catch (parseError) {
              console.warn('Failed to parse SSE data:', parseError);
            }
          }
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setAnalyzing(false);
      setProgress(0);
      setTargetProgress(0);
      setProgressMessage('');
    }
  };

  const handleGenerateCreatives = async () => {
    setLoading(true);
    setError(null);
    setProgress(0);
    setTargetProgress(0);
    setProgressMessage('Starting creative generation...');

    try {
      const payload = {
        brandName: brandName.trim(),
        websiteUrl,
        country,
        industryCategory,
        brandDescription,
        brandPersonality,
        keyCompetitors: keyCompetitors.split(',').map(c => c.trim()).filter(c => c),
        primaryCampaignGoal,
        ageGroups,
        gender,
        targetLocations: targetLocations.split(',').map(l => l.trim()).filter(l => l),
        languages: languages.split(',').map(l => l.trim()).filter(l => l),
        audienceType,
        offerType,
        offerDetails,
        creativeObjective,
        creativeFormats,
        additionalNotes,
        numberOfVariants,
        // Product analysis data from Step 1
        productAnalysis: productAnalysis,
        productImagePath: productImagePath,
        brandLogoPath: brandLogoPath,
        // Brand Guidelines (colors, fonts, content)
        brandGuidelines: {
          colorPalette: colorPalette,
          fonts: fonts,
          contentGuidelines: contentGuidelines
        },
        // Quality requirements
        requirements: {
          alwaysIncludeLogo: true,
          noFramesOrBorders: true,
          textOverlayLimit: 20, // Meta compliance: max 20% text
          ensureBrandConsistency: true,
          useExactBrandName: true // Don't append suffixes like "meta"
        }
      };

      const response = await fetch(`${API_URL}/generate-creatives-from-brief-sse`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n\n');

        // Keep the last incomplete line in buffer
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = JSON.parse(line.substring(6));

              if (data.error) {
                throw new Error(data.error);
              }

              if (data.progress !== undefined) {
                setTargetProgress(data.progress);
                setProgressMessage(data.message || '');
              }

              if (data.complete && data.data) {
                // Set progress to 100% first
                setTargetProgress(100);
                setProgressMessage('Complete!');

                // Wait for animation to reach 100% before proceeding
                setTimeout(() => {
                  setCreatives(data.data.creatives || []);
                  setStep(3);
                }, 1000); // Wait 1 second for animation to complete
              }
            } catch (parseError) {
              console.warn('Failed to parse SSE data:', parseError);
            }
          }
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setProgress(0);
      setTargetProgress(0);
      setProgressMessage('');
    }
  };

  const handleDownload = async (imageUrl, filename) => {
    try {
      const response = await fetch(`${API_URL}${imageUrl}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
      alert('Failed to download image');
    }
  };

  const toggleArrayValue = (array, setter, value) => {
    if (array.includes(value)) {
      setter(array.filter(v => v !== value));
    } else {
      setter([...array, value]);
    }
  };

  return (
    <div className="creative-brief-container">
      {(analyzing || loading) && progress > 0 && (
        <ProgressLoader progress={progress} message={progressMessage} />
      )}

      <div className="right-top-absolute">
        <img className="inline-flex 2xl:max-w-80 max-w-44" src="/upside_right.svg" alt="Ultra RightTop" />
      </div>

      <div className="left-bottom-absolute">
        <img className="inline-flex 2xl:max-w-72 max-w-40" src="/downside-left.svg" alt="Ultra RightTop" />
      </div>

      <header className="brief-header">
        <div className="header-title">
          <div className="title-group">
            <div className="main-title">
               <img src="/iris_logo.svg" alt="Ultra Iris Logo" className="ultra-iris-logo" />
            </div>
            <p className="header-subtitle">Professional Ad Creative Generator</p>
          </div>
        </div>
      </header>

      {error && (
        <div className="error-message">
          <p>❌ {error}</p>
        </div>
      )}

      {/* Step 1: Mandatory Fields */}
      {step === 1 && (
        <div className="brief-form">
          <h2 className="form-section-title">Step 1: Brand Information</h2>

          <div className="form-field">
            <label>Brand Name <span className="required">*</span></label>
            <input
              type="text"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
              placeholder="Enter your brand name"
              required
            />
          </div>

          <div className="form-field">
            <label>Website / App Link <span className="required">*</span></label>
            <input
              type="url"
              value={websiteUrl}
              onChange={(e) => setWebsiteUrl(e.target.value)}
              placeholder="https://www.yourbrand.com"
              required
            />
          </div>

          <div className="form-field">
            <label>Reference Ads (Upload Files) <span className="required">*</span></label>
            <input
              type="file"
              onChange={handleFileUpload}
              multiple
              accept="image/*"
            />
            {referenceAds.length > 0 && (
              <small className="file-count">{referenceAds.length} file(s) selected</small>
            )}
          </div>

          <div className="form-field" style={{ display: 'none' }}>
            <label>Reference Ads (URLs)</label>
            <textarea
              value={referenceAdUrls}
              onChange={(e) => setReferenceAdUrls(e.target.value)}
              placeholder="Paste image URLs or Meta ads library links here, one per line&#10;https://example.com/ad1.jpg&#10;https://www.facebook.com/ads/library/?id=5183792265178488"
              rows="3"
            />
            <small className="field-hint">Meta ads library links will be analyzed to extract creative style and elements. Provide either uploaded files or URLs (or both)</small>
          </div>

          <div className="form-field">
            <label>Country <span className="required">*</span></label>
            <select value={country} onChange={(e) => setCountry(e.target.value)} required>
              <option value="">Select country</option>
              {COUNTRIES.map(c => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>

          <div className="form-field">
            <label className="switch-label">
              <span className="switch-text">Is this a Product Ad?</span>
              <div className="switch-container">
                <input
                  type="checkbox"
                  checked={isProductAd}
                  onChange={(e) => setIsProductAd(e.target.checked)}
                  className="switch-checkbox"
                  id="product-ad-switch"
                />
                <label htmlFor="product-ad-switch" className="switch-slider"></label>
              </div>
            </label>
            <small className="field-hint">Enable if you have a specific product image to upload for accurate replication</small>
          </div>

          {isProductAd && (
            <div className="product-ad-section">
              <div className="section-header">
                <span className="section-icon">📦</span>
                <h3 className="section-title">Product Image</h3>
              </div>

              <div className="form-field">
                <label>Product Image (Optional)</label>
                <input
                  type="file"
                  onChange={handleProductImageUpload}
                  accept="image/*"
                />
                {productImage && (
                  <small className="file-count">✓ {productImage.name}</small>
                )}
                <small className="field-hint">
                  <strong>📸 Upload specific product image</strong> - AI will analyze and preserve exact product details (color, style, packaging, specifications)
                </small>
              </div>
            </div>
          )}

          <button
            className="primary-button"
            onClick={handleFetchDetails}
            disabled={!brandName || !websiteUrl || (referenceAds.length === 0 && !referenceAdUrls.trim()) || !country || analyzing}
          >
            {analyzing ? 'Analyzing Brand...' : 'Fetch Details →'}
          </button>
        </div>
      )}

      {/* Step 2: Auto-filled & Editable Fields */}
      {step === 2 && (
        <div className="brief-form">
          <h2 className="form-section-title">Step 2: Campaign Details</h2>
          <p className="form-subtitle">Review and edit the auto-filled information below</p>

          {/* Brand Guidelines Section - Compact Design */}
          <div className="form-section brand-guidelines-compact">
            <div className="guidelines-header-compact" onClick={() => setGuidelinesExpanded(!guidelinesExpanded)}>
              <div className="guidelines-title-row">
                <span className="guidelines-icon">🎨</span>
                <h3 className="guidelines-title">Brand Guidelines</h3>
              </div>
              <span className="accordion-arrow">{guidelinesExpanded ? '▲' : '▼'}</span>
            </div>

            {guidelinesExpanded && (
              <div className="guidelines-content-compact">
                {/* Tabs */}
                <div className="guidelines-tabs-compact">
                  <button
                    className={`tab-btn-compact ${activeGuidelineTab === 'design' ? 'active' : ''}`}
                    onClick={() => setActiveGuidelineTab('design')}
                    type="button"
                  >
                    Design
                  </button>
                  <button
                    className={`tab-btn-compact ${activeGuidelineTab === 'content' ? 'active' : ''}`}
                    onClick={() => setActiveGuidelineTab('content')}
                    type="button"
                  >
                    Content
                  </button>
                </div>

                {/* Design Tab */}
                {activeGuidelineTab === 'design' && (
                  <div className="tab-panel-compact">
                    {/* Logo Section */}
                    <div className="guidelines-section-compact">
                      <h4 className="section-label-compact">Logos</h4>
                      <div className="logos-row-compact">
                    {brandLogoPath ? (
                      <div className="logo-box-compact has-logo">
                        <img
                          src={`${API_URL}${brandLogoPath}`}
                          alt="Brand Logo"
                          className="logo-img-compact"
                        />
                      </div>
                    ) : (
                      <div className="logo-box-compact empty" onClick={() => document.getElementById('logo-upload-compact').click()}>
                        <span className="logo-placeholder-text">No logo</span>
                      </div>
                    )}

                    <div className="logo-box-compact add-logo" onClick={() => document.getElementById('logo-upload-compact').click()}>
                      <span className="add-icon-compact">+</span>
                      <span className="add-text-compact">Add logo</span>
                    </div>

                    <input
                      id="logo-upload-compact"
                      type="file"
                      onChange={handleBrandLogoUpload}
                      accept="image/png,image/jpeg,image/jpg,image/webp"
                      style={{ display: 'none' }}
                    />
                  </div>
                </div>

                {/* Colors Section */}
                <div className="guidelines-section-compact">
                  <div className="section-header-row-compact">
                    <h4 className="section-label-compact">Colors <span className="info-icon-compact">ⓘ</span></h4>
                  </div>
                  <div className="color-palette-label-compact">
                    Color palette <span className="edit-icon-compact">✎</span>
                  </div>
                  <div className="colors-row-compact">
                    <div className="color-circle-add-compact" onClick={handleOpenColorPicker}>
                      <span className="plus-compact">+</span>
                    </div>
                    {colorPalette.map((color, index) => (
                      <div key={index} className="color-item-compact">
                        <div className="color-circle-compact" style={{ backgroundColor: color }}>
                          <button
                            className="remove-x-compact"
                            onClick={() => handleRemoveColor(index)}
                            type="button"
                          >
                            ×
                          </button>
                        </div>
                        <span className="color-code-compact">{color}</span>
                      </div>
                    ))}
                  </div>
                  <button className="add-palette-button-compact" onClick={handleOpenColorPicker} type="button">
                    Add palette <span className="plus-compact">+</span>
                  </button>
                </div>

                {/* Fonts Section */}
                <div className="guidelines-section-compact">
                  <div className="section-header-row-compact">
                    <h4 className="section-label-compact">Fonts <span className="info-icon-compact">ⓘ</span></h4>
                    <span className="uploaded-fonts-link">Uploaded Fonts</span>
                  </div>
                  <div className="fonts-list-compact">
                    {fonts.map((fontEntry, index) => (
                      <div key={index} className="font-item-compact-wrapper">
                        <div className="font-item-compact" style={{ fontFamily: fontEntry.family || fontEntry }}>
                          <div className="font-name-display-compact">{fontEntry.family || fontEntry} ({fontEntry.usage || 'Primary'})</div>
                        </div>
                        <button
                          className="font-remove-compact"
                          onClick={() => handleRemoveFont(index)}
                          type="button"
                          title="Remove font"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                  <button className="add-font-button-compact" onClick={handleOpenFontPicker} type="button">
                    Add font style <span className="plus-compact">+</span>
                  </button>
                </div>
                  </div>
                )}

                {/* Content Tab */}
                {activeGuidelineTab === 'content' && (
                  <div className="tab-panel-compact">
                    {/* Content Guidelines Section */}
                    <div className="guidelines-section-compact">
                      <div className="section-header-row-compact">
                        <h4 className="section-label-compact">Content Guidelines</h4>
                        {!isEditingContent && (
                          <button className="edit-link-compact" onClick={handleEditContent} type="button">
                            Edit
                          </button>
                        )}
                      </div>
                      {!isEditingContent ? (
                        <div className="content-preview-compact">
                          {contentGuidelines || <em className="content-empty-compact">No content guidelines set yet.</em>}
                        </div>
                      ) : (
                        <>
                          <textarea
                            className="content-textarea-compact"
                            value={contentGuidelines}
                            onChange={(e) => setContentGuidelines(e.target.value)}
                            placeholder="Define writing style, tone, words to avoid, required disclaimers..."
                            rows="6"
                          />
                          <div className="content-actions-compact">
                            <button className="save-btn-compact" onClick={handleSaveContent} type="button">
                              Save
                            </button>
                            <button className="cancel-btn-compact" onClick={handleCancelContentEdit} type="button">
                              Cancel
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Brand Information Section */}
          <div className="form-section">
            <h3 className="section-header">📋 Brand Information</h3>

            <div className="form-field form-width-short">
              <label>Industry / Category</label>
              <select value={industryCategory} onChange={(e) => setIndustryCategory(e.target.value)}>
                <option value="">Select industry</option>
                {INDUSTRIES.map(ind => (
                  <option key={ind} value={ind}>{ind}</option>
                ))}
              </select>
            </div>

            <div className="form-field">
              <label>Brand Description</label>
              <textarea
                value={brandDescription}
                onChange={(e) => setBrandDescription(e.target.value)}
                placeholder="Describe your brand, offering, and value proposition..."
                rows="3"
              />
            </div>

            <div className="form-field">
              <label>Brand Personality</label>
              <div className="checkbox-grid">
                {BRAND_PERSONALITIES.map(personality => (
                  <label key={personality} className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={brandPersonality.includes(personality)}
                      onChange={() => toggleArrayValue(brandPersonality, setBrandPersonality, personality)}
                    />
                    {personality}
                  </label>
                ))}
              </div>
            </div>

            <div className="form-field">
              <label>Key Competitors <span className="required">*</span></label>
              <input
                type="text"
                value={keyCompetitors}
                onChange={(e) => setKeyCompetitors(e.target.value)}
                placeholder="Competitor 1, Competitor 2, Competitor 3"
                required
              />
              <small className="field-hint">Separate multiple competitors with commas</small>
            </div>
          </div>

          {/* Campaign Goals Section */}
          <div className="form-section">
            <h3 className="section-header">🎯 Campaign Goals</h3>

            <div className="form-field form-width-short">
              <label>Primary Campaign Goal <span className="required">*</span></label>
              <select value={primaryCampaignGoal} onChange={(e) => setPrimaryCampaignGoal(e.target.value)} required>
                <option value="">Select campaign goal</option>
                {CAMPAIGN_GOALS.map(goal => (
                  <option key={goal} value={goal}>{goal}</option>
                ))}
              </select>
            </div>

            <div className="form-field form-width-short">
              <label>Creative Objective <span className="required">*</span></label>
              <select value={creativeObjective} onChange={(e) => setCreativeObjective(e.target.value)} required>
                <option value="">Select creative objective</option>
                {CREATIVE_OBJECTIVES.map(obj => (
                  <option key={obj} value={obj}>{obj}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Target Audience Section */}
          <div className="form-section">
            <h3 className="section-header">👥 Target Audience</h3>

            <div className="form-field">
              <label>Age Group <span className="required">*</span></label>
              <div className="checkbox-grid">
                {AGE_GROUPS.map(age => (
                  <label key={age} className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={ageGroups.includes(age)}
                      onChange={() => toggleArrayValue(ageGroups, setAgeGroups, age)}
                    />
                    {age} Years
                  </label>
                ))}
              </div>
            </div>

            <div className="form-field form-width-short">
              <label>Gender <span className="required">*</span></label>
              <select value={gender} onChange={(e) => setGender(e.target.value)} required>
                {GENDERS.map(g => (
                  <option key={g} value={g}>{g}</option>
                ))}
              </select>
            </div>

            <div className="form-field">
              <label>Target Location <span className="required">*</span></label>
              <input
                type="text"
                value={targetLocations}
                onChange={(e) => setTargetLocations(e.target.value)}
                placeholder="Mumbai, Delhi, Bangalore"
                required
              />
              <small className="field-hint">Separate multiple locations with commas</small>
            </div>

            <div className="form-field">
              <label>Languages <span className="required">*</span></label>
              <input
                type="text"
                value={languages}
                onChange={(e) => setLanguages(e.target.value)}
                placeholder="English, Hindi"
                required
              />
              <small className="field-hint">Separate multiple languages with commas</small>
            </div>

            <div className="form-field">
              <label>Audience Type <span className="required">*</span></label>
              <div className="checkbox-grid">
                {AUDIENCE_TYPES.map(type => (
                  <label key={type} className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={audienceType.includes(type)}
                      onChange={() => toggleArrayValue(audienceType, setAudienceType, type)}
                    />
                    {type}
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Offer & Creative Requirements Section */}
          <div className="form-section">
            <h3 className="section-header">💰 Offer & Creative Requirements</h3>

            <div className="form-field form-width-short">
              <label>Offer Type <span className="required">*</span></label>
              <select value={offerType} onChange={(e) => setOfferType(e.target.value)} required>
                <option value="">Select offer type</option>
                {OFFER_TYPES.map(offer => (
                  <option key={offer} value={offer}>{offer}</option>
                ))}
              </select>
            </div>

            <div className="form-field">
              <label>Offer Details</label>
              <input
                type="text"
                value={offerDetails}
                onChange={(e) => setOfferDetails(e.target.value)}
                placeholder="e.g., Flat 30% off on all eyewear"
              />
            </div>

            <div className="form-field">
              <label>Required Creative Formats <span className="required">*</span></label>
              <div className="checkbox-grid">
              {CREATIVE_FORMATS.map(format => (
                <label key={format.value} className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={creativeFormats.includes(format.value)}
                    onChange={() => toggleArrayValue(creativeFormats, setCreativeFormats, format.value)}
                  />
                  {format.label}
                </label>
              ))}
              </div>
            </div>

            <div className="form-field form-width-short">
              <label>Number of Variants per Format <span className="required">*</span></label>
              <input
                type="number"
                min="1"
                max="5"
                value={numberOfVariants}
                onChange={(e) => setNumberOfVariants(parseInt(e.target.value))}
                required
              />
              <small className="field-hint">How many style variations to generate for each selected format</small>
            </div>
          </div>

          {/* Additional Notes Section */}
          <div className="form-section">
            <h3 className="section-header">📝 Additional Notes</h3>
            <div className="form-field">
              <label>Additional Notes</label>
              <textarea
                value={additionalNotes}
                onChange={(e) => setAdditionalNotes(e.target.value)}
                placeholder="Any special instructions, do's and don'ts for the creatives..."
                rows="4"
              />
            </div>
          </div>

          {/* Color Picker Modal - Compact */}
          {isColorPickerOpen && (
            <div className="modal-overlay-compact" onClick={() => setIsColorPickerOpen(false)}>
              <div className="color-picker-modal-compact" onClick={(e) => e.stopPropagation()}>
                {/* Header with Hex and Close */}
                <div className="color-modal-header-compact">
                  <div className="hex-display-compact">
                    <span className="hex-text-compact">{tempColorHex}</span>
                    <button className="edit-hex-icon-compact" type="button">✎</button>
                  </div>
                  <button className="close-modal-compact" onClick={() => setIsColorPickerOpen(false)} type="button">
                    ×
                  </button>
                </div>

                {/* 2D Gradient Picker */}
                <div
                  className="gradient-picker-compact"
                  onMouseDown={handleGradientMouseDown}
                  style={{
                    background: `linear-gradient(to bottom, transparent, black), linear-gradient(to right, white, hsl(${hue}, 100%, 50%))`
                  }}
                >
                  <div
                    className="gradient-cursor-compact"
                    style={{
                      left: `${saturation}%`,
                      top: `${100 - brightness}%`
                    }}
                  />
                </div>

                {/* Hue Slider */}
                <input
                  type="range"
                  min="0"
                  max="360"
                  value={hue}
                  onChange={handleHueChange}
                  className="hue-slider-compact"
                />

                {/* Bottom Section: Color Preview + Hex Input + Copy */}
                <div className="color-input-row-compact">
                  <div
                    className="color-preview-square-compact"
                    style={{ backgroundColor: tempColor }}
                  />
                  <input
                    type="text"
                    value={tempColorHex}
                    onChange={handleColorHexChange}
                    className="hex-input-compact"
                    maxLength="7"
                  />
                  <button
                    className="copy-icon-button-compact"
                    onClick={handleCopyHex}
                    type="button"
                    title="Copy color code"
                  >
                    📋
                  </button>
                </div>

                {/* Apply Button */}
                <button className="apply-color-button-compact" onClick={handleConfirmColor} type="button">
                  Apply
                </button>
              </div>
            </div>
          )}

          {/* Copy Toast Notification */}
          {showCopyToast && (
            <div className="copy-toast">
              <span className="toast-icon">✓</span>
              <span className="toast-text">Color copied to clipboard</span>
            </div>
          )}

          {/* Font Picker Modal */}
          {isFontPickerOpen && (
            <div className="modal-overlay" onClick={() => setIsFontPickerOpen(false)}>
              <div className="modal-content font-picker-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>Add Font Style</h3>
                  <button className="modal-close" onClick={() => setIsFontPickerOpen(false)}>×</button>
                </div>
                <div className="modal-body">
                  {/* Font Usage & Family Dropdowns */}
                  <div className="font-selectors-row">
                    <div className="font-usage-selector">
                      <select
                        value={tempFontUsage}
                        onChange={(e) => {
                          setTempFontUsage(e.target.value);
                          setFontDropdownOpen(false); // Close dropdown when changing usage type
                        }}
                        className="font-usage-select"
                      >
                        {FONT_USAGE_TYPES.map(usage => (
                          <option key={usage} value={usage}>{usage}</option>
                        ))}
                      </select>
                    </div>
                    <div className="font-family-selector">
                      <div className="font-dropdown">
                        <input
                          type="text"
                          value={tempFontFamily}
                          readOnly
                          className="font-dropdown-input"
                          onClick={toggleFontDropdown}
                        />
                        {/* Search Input */}
                        {fontDropdownOpen && (
                        <div className="font-search-dropdown">
                          <input
                            type="text"
                            placeholder="Search fonts"
                            value={fontSearchQuery}
                            onChange={(e) => setFontSearchQuery(e.target.value)}
                            className="font-search-input"
                          />
                          <div className="font-list">
                            <div className="font-list-header">Google fonts</div>
                            {filteredFonts.map(font => (
                              <div
                                key={font}
                                className="font-list-item"
                                onClick={() => handleFontFamilyChange(font)}
                                style={{ fontFamily: font }}
                              >
                                {font}
                                {tempFontFamily === font && <span className="font-selected-check">✓</span>}
                              </div>
                            ))}
                          </div>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Typography Preview */}
                  <div className="typography-preview">
                    <h4>Typography sample</h4>
                    <div className="typography-sample" style={{ fontFamily: tempFontFamily }}>
                      The quick brown fox jumps over the lazy dog
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="apply-button" onClick={handleConfirmFont}>Apply</button>
                </div>
              </div>
            </div>
          )}

          <div className="button-group">
            <button
              type="button"
              className="secondary-button"
              onClick={() => setStep(1)}
            >
              ← Back
            </button>
            <button
              type="button"
              className="primary-button"
              onClick={handleGenerateCreatives}
              disabled={loading || !keyCompetitors || !primaryCampaignGoal || ageGroups.length === 0 || !gender || !targetLocations || !languages || audienceType.length === 0 || !offerType || !creativeObjective || creativeFormats.length === 0}
            >
              {loading ? 'Generating Creatives...' : 'Generate Creatives 🎨'}
            </button>
          </div>
        </div>
      )}

      {/* Step 3: Results */}
      {step === 3 && creatives.length > 0 && (
        <div className="results-container">
          {/* <h2 className="results-title">Generated Creatives</h2> */}
          <p className="results-subtitle">Your Meta-compliant ad creatives are ready!</p>

          
          <div className="creatives-grid">
            {creatives.map((creative) => (
              <div key={creative.variantNumber} className="creative-card">
                

                {creative.imageUrl && (
                  <div className="image-container">
                    <img
                      src={`${API_URL}${creative.imageUrl}`}
                      alt={creative.style}
                      loading="lazy"
                    />
                  </div>
                )}

                <div className="creative-header">
                  <h3>{creative.format}</h3>
                  <span className="variant-badge">{creative.style}</span>
                </div>

                {creative.description && (
                  <div className="description">
                    <p>{creative.description}</p>
                  </div>
                )}

                {creative.imageUrl && (
                  <div className="action-buttons">
                    <a
                      href={`${API_URL}${creative.imageUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="view-link"
                    >
                      View Full →
                    </a>
                    <button
                      onClick={() => handleDownload(
                        creative.imageUrl,
                        `${brandName}-${creative.format}-${creative.variantNumber}.png`
                      )}
                      className="download-link"
                    >
                      ⬇ Download
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="button-group">
            <button
              className="secondary-button"
              onClick={() => setStep(2)}
            >
              ← Back to Edit Details
            </button>
            <button
              className="secondary-button solid-bg"
              onClick={() => {
                setStep(1);
                setCreatives([]);
              }}
            >
              Create New Campaign
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreativeBriefForm;
